<template>
  <div>
    <b-container>
      <dashboard-estate-agent v-if="isEstateAgent"/>
      <dashboard-collaborator v-if="isCollaborator||isCollaboratorPlus"/>
      <dashboard-client v-if="isAdmin"/>
    </b-container>
  </div>
</template>

<script>
import DashboardCollaborator from "./DashboardCollaborator";
import DashboardEstateAgent from "./DashboardEstateAgent";
import DashboardAdmin from "./DashboardAdmin";
import DashboardClient from "../client/DashboardClient.vue";

export default {
  name: 'Dashboard',
  components: {
    DashboardEstateAgent,
    DashboardCollaborator,
    DashboardClient,
  },
  computed: {
    isCollaborator() {
      return this.$store.getters.isCollaborator;
    },
    isCollaboratorPlus() {
      return this.$store.getters.isCollaboratorPlus;
    },
    isEstateAgent() {
      return this.$store.getters.isEstateAgent;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/dashboard/Dashboard.vue